import React from 'react';

interface Props {
    nome: string;
    className?: string;
}

const Icone = ({ nome, className = '' }: Props): React.ReactElement =>
{
    return (
        <i className={ `bi bi-${nome} ${className}` }></i>
    )
}

export default Icone;
